import { AccountingFirmTier } from '@melio/accountants-service-client/dist/models';
import { DiscountTierName } from '@melio/subscription-service-client/dist/models';

const accountingFirmTierToDiscountTier: Record<
  AccountingFirmTier,
  DiscountTierName
> = {
  [AccountingFirmTier.Tier1]: DiscountTierName.Tier1,
  [AccountingFirmTier.Tier2]: DiscountTierName.Tier2,
  [AccountingFirmTier.Tier3]: DiscountTierName.Tier3,
  [AccountingFirmTier.Tier4]: DiscountTierName.Tier4
};

export const mapAccountingFirmTierToDiscountTier = (
  tier: AccountingFirmTier | null | undefined
): DiscountTierName | null | undefined => {
  if (!tier) {
    return null;
  }

  return accountingFirmTierToDiscountTier[tier];
};
